import { useClientBookingContext } from "@/contexts/clientBookingContext";
import { useDisabledServiceIds } from "@/utils/booking";
import { MedspaInfo } from "@/views/booking/bookingView";

export default function useBookingServiceSelection() {
  const { medspaData, eligibleProviders, setSelectedServices } =
    useClientBookingContext();
  // CALCULATED PROPERTIES
  const disabledServiceIds = useDisabledServiceIds(
    eligibleProviders,
    medspaData.serviceMenuItems
  );

  // ACTIONS
  const onSelect = (service: MedspaInfo["serviceMenuItems"][number]) => {
    setSelectedServices((currentServices) => {
      const isAlreadySelected = currentServices.some(
        (selectedService) => selectedService.id === service.id
      );
      if (isAlreadySelected) {
        return currentServices.filter(
          (selectedService) => selectedService.id !== service.id
        );
      }
      return [...currentServices, service];
    });
  };

  return {
    disabledServiceIds,
    onSelect,
  };
}
